export const checkIsFilterUsed = ({ searchParamGroup }) =>
  Boolean(
    searchParamGroup.question_type ||
      searchParamGroup.creator_type ||
      searchParamGroup.from ||
      searchParamGroup.to,
  )
